import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from '../App';
// Import global styles
import '../styles/tokens.css';
import '../styles/global.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}
// Hydrate the server-rendered HTML
hydrateRoot(rootElement, React.createElement(React.StrictMode, null,
    React.createElement(App, { url: window.location.pathname })));
// Enable HMR in development
if (import.meta.webpackHot) {
    import.meta.webpackHot.accept();
}
